const hasValidCoordinates = (lat, lng) =>
  Number.isFinite(Number(lat)) &&
  Number.isFinite(Number(lng)) &&
  !(Number(lat) === 0 && Number(lng) === 0);

const normalizeLocationSearchMode = (value = "") =>
  String(value || "")
    .trim()
    .toLowerCase();

const isCityLevelHelperLocationSearch = ({
  locationData = {},
  locationSearchMode = "",
} = {}) => {
  const mode = normalizeLocationSearchMode(
    locationSearchMode || locationData?.locationSearchMode,
  );

  if (mode === "exact" || mode === "home" || mode === "street") {
    return false;
  }
  if (mode === "city" || mode === "ip" || mode === "route") {
    return true;
  }

  const addressType = normalizeLocationSearchMode(locationData?.addressType);
  if (addressType === "home" || addressType === "street") return false;
  if (addressType === "city") return true;

  const line1 = String(
    locationData?.line1 ||
      locationData?.addressLine1 ||
      locationData?.street ||
      locationData?.streetAddress ||
      "",
  ).trim();
  if (line1) return false;

  const source = normalizeLocationSearchMode(
    locationData?.locationSource || locationData?.source,
  );
  if (
    source === "ip" ||
    source === "member_city_seo" ||
    source === "member_seo"
  ) {
    return true;
  }

  return Boolean(
    hasValidCoordinates(
      locationData?.latitude ?? locationData?.lat,
      locationData?.longitude ?? locationData?.lng,
    ),
  );
};

module.exports = { hasValidCoordinates, isCityLevelHelperLocationSearch };
